<template>
	<section class="container my-4">
		<b class="mb-4" style="font-size: 26px; padding-top: 60px">{{ $t('exchange.ln_5') }}</b>
		<br>
		<br>
		<b-row>
			<b-col lg="6">
			<b-card no-body class="mb-4" style="border-radius: 12px; border-color: transparent;">
				<div style="background-color: #ffffff; border-radius: 12px;" class="coinmarketcap-currency-widget" data-currencyid="8820" data-base="USD" data-secondary="BTC" data-ticker="true" data-rank="true" data-marketcap="true" data-volume="true" data-statsticker="true" data-stats="USD" ></div>
			</b-card>
			</b-col>
			<b-col lg="6">
				<b-card no-body class="mb-4" style="border-radius: 11px; border: 2px solid #e1e5ea">
					<div>
						<iframe scrolling="no" align="center" frameborder="no" marginheight="5px" marginwidth="5px" style="min-height: 170px; width: 100%; border-radius: 11px; border-color: transparent" src="https://widget.coincodex.com/?type=1&ticker=evrice&history_days=30&chartLineColor=1f79e1&chartFillColor=e8f1fc&textColor1=1e2e42&textColor2=617283&linkColor=4a90e2&backgroundColor=ffffff&borderColor=transparent"></iframe>
					</div>
					<div>
						<iframe scrolling="no" align="center" frameborder="no" style="height: 32px; width: 100%; max-width: 100%; border-radius: 11px; border-color: transparent" src="https://widget.coincodex.com/?type=4&ticker=top10&period=1D&textColor=000000&backgroundColor=ffffff&hoverColor=transparent&currency=USD&range=1D&borderColor=transparent"></iframe>
					</div>
				</b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col lg="3">
				<b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; min-height: 90px; box-shadow: none ">
					<a href="https://coinmarketcap.com/currencies/evrice/" target="_blank"><b-img width="180" style="text-align: center; margin-top: 10px" src="../assets/img/service/cmc.png"/></a>
				</b-card>
			</b-col>
			<b-col lg="3">
				<b-card class="text-center mb-4 " style="border-color: transparent; background-color: transparent; min-height: 90px; box-shadow: none">
					<a href="https://www.coingecko.com/en/coins/evrice" target="_blank"><b-img width="180" style="text-align: center; line-height: normal" src="../assets/img/service/coingecko.png"/></a>
				</b-card>
			</b-col>
			<b-col lg="3">
				<b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; min-height: 90px; box-shadow: none">
					<a href="https://coincodex.com/crypto/evrice/" target="_blank"><b-img width="180" style="text-align: center" src="../assets/img/service/coincodex.png"/></a>
				</b-card>
			</b-col>
			<b-col lg="3">
				<b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; min-height: 90px; box-shadow: none">
					<a href="https://coincost.net/en/currency/evrice" target="_blank"><b-img width="180" style="text-align: center; margin-top: 10px" src="../assets/img/service/coincost.png"/></a>
				</b-card>
			</b-col>
		</b-row>
		<hr>

		<b class="mb-4" style="font-size: 26px; padding-top: 60px">{{ $t('exchange.ln_1') }}</b>
		<br>
		<b-row>
			<b-col lg="6">
				<br>
				<b-card no-body class="mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
					<b-card-body>
						<b-row no-gutters>
							<b-col lg="6" style="text-align:  center">
								<a href="https://bitexbook.com/" target="_blank"><b-img width="200" src="../assets/img/home/Bitexbook.png" style="padding-top: 15px"/></a>
							</b-col>
							<b-col lg="6">
								<b-list-group>
									<b-list-group-item style="border:0; font-size: 20px; text-align:  center; padding: 0px; background-color: transparent">
										<a style=""><b>{{$t('exchange.ln_3')}}</b></a>
									</b-list-group-item>
									<b-list-group-item  style="border:0; padding: 1px; background-color: transparent">
										<b-button class="w-100 mb-1" href="https://bitexbook.com/en/trading/evcrub" target="_blank" variant="light">EVC | RUB</b-button>
									</b-list-group-item>
									<b-list-group-item style="border:0; padding: 1px; background-color: transparent">
										<b-button class="w-100 my-1" href="https://bitexbook.com/en/trading/evcbtc" target="_blank" variant="light">EVC | BTC</b-button>
									</b-list-group-item>
									<b-list-group-item style="border:0; padding: 1px; background-color: transparent">
										<b-button class="w-100 my-1" href="https://bitexbook.com/en/trading/evceth" target="_blank" variant="light">EVC | ETH</b-button>
									</b-list-group-item>
								</b-list-group>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
      <b-col lg="6">
        <br>
        <b-card no-body class="mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
          <b-card-body>
            <b-row no-gutters>
              <b-col lg="6" style="text-align:  center">
                <a href="https://folgory.com/" target="_blank"><b-img width="200" src="../assets/img/home/folgory.png" style="padding-top: 15px"/></a>
              </b-col>
              <b-col lg="6">
                <b-list-group>
                  <b-list-group-item style="border:0; font-size: 20px; text-align:  center; padding: 0px; background-color: transparent">
                    <a style=""><b>{{$t('exchange.ln_3')}}</b></a>
                  </b-list-group-item>
                  <b-list-group-item style="border:0; padding: 1px; background-color: transparent">
                    <b-button class="w-100 my-1" href="https://folgory.com/trade-crypto/EVC_BTC" target="_blank" variant="light">EVC | BTC</b-button>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
		</b-row>
		<hr>
		<div id="script_block" class="script_block"></div>
	</section>
</template>


<script lang="js">
	setTimeout(function() {
		var script = document.createElement('script');
		script.src = 'https://files.coinmarketcap.com/static/widget/currency.js';
		script.type = 'text/javascript';
		document.head.appendChild(script);
	}, 1000);

	export default {
		name: "exchange.main",
		data() {
			return {}
		},
		metaInfo () {
			return {
				title: 'Exchange'
			}
		},
	}
</script>



<style scoped>

	.trs {
		border-right: 1px solid #edeef0;
		text-align: center;
	}

</style>